import { Link } from 'react-router-dom';

const heroBgImage = 'https://readdy.ai/api/search-image?query=A%20beautiful%20artistic%20abstract%20background%20in%20warm%20orange%20coral%20and%20soft%20peach%20tones%2C%20dreamy%20soft%20gradients%20with%20floating%20particles%2C%20Japanese%20manga%20aesthetic%20style%2C%20clean%20elegant%20composition%2C%20warm%20inviting%20atmosphere%2C%20ink%20wash%20texture%2C%20no%20text%2C%20abstract%20art&width=1800&height=900&seq=hero-bg-manga&orientation=landscape';

export default function HeroBanner() {
  return (
    <section className="relative w-full h-[500px] md:h-[620px] flex items-center justify-center overflow-hidden" aria-label="首页横幅">
      <img
        src={heroBgImage}
        alt="叮当漫画网首页背景"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/30 to-black/55"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 bg-primary-500/20 backdrop-blur-sm border border-primary-400/30 rounded-full mb-6">
          <span className="w-2 h-2 rounded-full bg-accent-500 animate-pulse"></span>
          <span className="text-xs md:text-sm text-white/90 font-medium">每日更新 · 完全免费 · 无删减</span>
        </div>

        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading text-white mb-4 leading-tight tracking-wider">
          大黄丫头漫画
        </h1>
        <p className="text-base md:text-lg text-white/80 max-w-2xl mx-auto mb-8 leading-relaxed">
          无删减漫画下拉式免费阅读，叮当漫画网为您呈现最完整的漫画内容。<br className="hidden sm:block" />
          无需付费，无需等待，随时随地畅享追漫乐趣。
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/comic/dahuang-yatou"
            className="px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold rounded-full transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer text-sm md:text-base"
          >
            <span className="flex items-center gap-2">
              <span className="w-5 h-5 flex items-center justify-center">
                <i className="ri-play-circle-fill text-lg"></i>
              </span>
              开始阅读大黄丫头
            </span>
          </Link>
          <Link
            to="/category/rexue"
            className="px-8 py-3.5 bg-white/10 hover:bg-white/20 backdrop-blur-sm text-white font-medium rounded-full border border-white/30 transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer text-sm md:text-base"
          >
            <span className="flex items-center gap-2">
              <span className="w-5 h-5 flex items-center justify-center">
                <i className="ri-compass-3-line text-lg"></i>
              </span>
              探索更多漫画
            </span>
          </Link>
        </div>

        <div className="mt-10 flex items-center justify-center gap-8">
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-bold text-white">10,000+</p>
            <p className="text-xs md:text-sm text-white/60 mt-1">漫画资源</p>
          </div>
          <div className="w-px h-10 bg-white/20"></div>
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-bold text-white">500万+</p>
            <p className="text-xs md:text-sm text-white/60 mt-1">活跃读者</p>
          </div>
          <div className="w-px h-10 bg-white/20"></div>
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-bold text-white">每日更新</p>
            <p className="text-xs md:text-sm text-white/60 mt-1">从不间断</p>
          </div>
        </div>
      </div>
    </section>
  );
}